import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import living_room from '../../assets/images/living_room.png';
import electromenager from '../../assets/images/climatiseurs-mono-split.png.webp';
import decor from '../../assets/images/decor.png';
import divers from '../../assets/images/lighting.png';
import revetement from '../../assets/images/revetement.jpg';

const categories = [
    {
        id: 1,
        name: 'Mobilier',
        count: 'Découvrir',
        image: living_room,
        gridClass: 'md:col-span-2 md:row-span-2',
    },
    {
        id: 2,
        name: 'Decorations',
        count: 'Découvrir',
        image: decor,
        gridClass: 'md:col-span-1 md:row-span-2',
    },
    {
        id: 3,
        name: 'Electromenager',
        count: 'Découvrir',
        image: electromenager, // Placeholder for cuisine
        gridClass: 'md:col-span-1 md:row-span-1',
    },
    {
        id: 4,
        name: 'Revêtements',
        count: 'Découvrir',
        image: revetement,
        gridClass: 'md:col-span-1 md:row-span-1',
    },
    {
        id: 5,
        name: 'Divers',
        count: 'Découvrir',
        image: divers,
        gridClass: 'md:col-span-1 md:row-span-1',
    },

];

const CategoryGrid = () => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
                    <div className="max-w-xl">
                        <h2 className="text-sm font-bold tracking-[0.2em] text-green-500 uppercase mb-4">Catégories</h2>
                        <h3 className="text-4xl md:text-5xl font-bold text-green-900 leading-tight">
                            Collections Sélectionnées pour Chaque Espace
                        </h3>
                    </div>
                    <Link to="/categories" className="text-green-700 font-bold flex items-center gap-2 group border-b-2 border-green-700 pb-1 hover:text-green-600 hover:border-green-600 transition-all">
                        Voir Toutes les Catégories
                        <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[350px]">
                    {categories.map((category) => (
                        <div
                            key={category.id}
                            className={`group relative overflow-hidden rounded-[2.5rem] bg-green-50 cursor-pointer ${category.gridClass}`}
                        >
                            <img
                                src={category.image}
                                alt={category.name}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-green-900/80 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500"></div>

                            <div className="absolute inset-0 p-10 flex flex-col justify-end">
                                <p className="text-sm font-medium text-white/70 mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 opacity-0 group-hover:opacity-100">
                                    {category.count}
                                </p>
                                <h4 className="text-3xl font-bold text-white mb-2">
                                    {category.name}
                                </h4>
                                <div className="w-12 h-1 bg-white transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-100"></div>
                            </div>

                            {/* Hover Icon */}
                            <div className="absolute top-8 right-8 w-12 h-12 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                <ArrowUpRight className="w-6 h-6" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CategoryGrid;
